import React from 'react';

const OrderDetailsModal = ({ onClose, orderDetails }) => {
  if (!orderDetails) return null; 

  const {
    productName = 'Product',
    points = 0,
    quantity = 1,
    orderedOn = '', 
    imageUrl = 'https://cdn-icons-png.flaticon.com/512/436/436114.png', 
    productCode = '',
  } = orderDetails;

  const styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 1000,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    modal: {
      backgroundColor: '#fff',
      borderRadius: '8px',
      width: '90%',
      maxWidth: '400px',
      padding: '20px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
      position: 'relative',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '1px solid #ddd',
      paddingBottom: '8px',
    },
    title: {
      margin: 0,
      fontWeight: 600,
      fontSize: '16px',
    },
    closeBtn: {
      background: 'none',
      border: 'none',
      fontSize: '20px',
      cursor: 'pointer',
    },
    body: {
      paddingTop: '15px',
    },
    item: {
      display: 'flex',
      alignItems: 'center',
    },
    image: {
      width: '40px',
      height: '40px',
      marginRight: '15px',
    },
    info: {
      flex: 1,
    },
    productName: {
      fontWeight: 600,
      marginBottom: '4px',
    },
    details: {
      fontSize: '14px',
      color: '#555',
      marginBottom: '2px',
    },
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.header}>
          <h5 style={styles.title}>Order Details</h5>
          <button style={styles.closeBtn} onClick={onClose}>&times;</button>
        </div>

        <div style={styles.body}>
          <div style={styles.item}>
            <img
              src={imageUrl}
              alt={productName}
              style={styles.image}
            />
            <div style={styles.info}>
              <p style={styles.productName}>{productName} {productCode ? `(${productCode})` : ''}</p>
              <p style={styles.details}>{points} Points* (QTY: {quantity})</p>
              <p style={styles.details}>Ordered on {orderedOn}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetailsModal;

